<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="gift-box">
        <div
          v-for="(item, key) in giftData.list"
          :key="key"
          class="gift-item"
        >
          <div class="image">
            <img :src="getGiftImg(item.icon)" />
          </div>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
      <div class="bottom">
        <div class="reward-btn" @click="openBindDialog"></div>
        <div class="tips">仅限官网安卓、iOS下载用户领取</div>
      </div>
      <div class="character"></div>
    </div>
    <bind-dialog :visible.sync="bindDialogVisible" :prizeList="giftLog" type="down" />
  </div>
</template>

<script>
import downloadMixins from '@/mixins/home/downloadMixins'

import BindDialog from '@/views/pc/components/bindDialog/Index.vue'

export default {
  name: 'PcHomeDownload',
  mixins: [downloadMixins],
  components: {
    BindDialog,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/pc/btns.scss';

.module {
  height: 1020px;

  &__title {
    background-position: center -384px;
  }

  &__content {
    position: absolute;
    left: 50%;
    transform: translateX(-547px);
    margin-top: 82px;
    width: 1016px;
    height: 267px;
    background: url('~@/assets/img/pc/download_gift_box.png') no-repeat;
  }
}

.gift-box {
  position: absolute;
  display: flex;
  justify-content: space-evenly;
  margin-left: 50px;
  width: 710px;
  height: 267px;
}

.gift-item {
  display: flex;
  flex-direction: column;
  margin-top: 47px;
  width: 172px;

  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 172px;
    height: 155px;
    background: url('~@/assets/img/pc/prize_bg2.png') no-repeat;

    img {
      width: 100px;
      height: 100px;
    }
  }

  .name {
    margin-top: 10px;
    width: 100%;
    text-align: center;
    color: #584c45;
    font-size: 16px;
  }
}

.bottom {
  position: absolute;
  bottom: -169px;
  left: 207px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .rule {
    margin-top: 12px;
    font-size: 20px;
    color: #3479a5;
    cursor: pointer;
    
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: #3479a5;
    }
  }

  .tips {
    margin-top: 10px;
    color: #584c45;
  }
}

.reward-btn {
  width: 391px;
  height: 96px;
  background: url('~@/assets/img/pc/download_gift_btn.png') no-repeat;
  background-position: 0 0;
  cursor: pointer;

  &:hover {
    background-position: 0 -96px;
  }
}

.character {
  position: absolute;
  bottom: -405px;
  right: -490px;
  width: 893px;
  height: 924px;
  background: url('~@/assets/img/pc/character3.png') no-repeat;
}
</style>